var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnlargeIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Enlarge-Icn_svg__clip0_1847_1787)",
    fill: "#1D1D1B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.61 25.11h-6.5v-6.5h-2v6.5h-6.5v2h6.5v6.5h2v-6.5h6.5v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.11 52.22C11.71 52.22 0 40.5 0 26.11 0 11.72 11.71 0 26.11 0c14.4 0 26.11 11.71 26.11 26.11 0 14.4-11.71 26.11-26.11 26.11zm0-50.22C12.82 2 2 12.82 2 26.11s10.82 24.11 24.11 24.11 24.11-10.81 24.11-24.11C50.22 12.81 39.4 2 26.11 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Enlarge-Icn_svg__clip0_1847_1787"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52.22v52.22H0z"
  })))));
}

export default SvgEnlargeIcn;